module.exports = __webpack_public_path__ + "static/media/shoutLogo.f80d6a0b.png";